import { render, staticRenderFns } from "./modal-search-cliente.vue?vue&type=template&id=04cef408"
import script from "./modal-search-cliente.vue?vue&type=script&lang=js"
export * from "./modal-search-cliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports